<footer id="wcaFooter" tabindex="0" *ngIf="isUHFRequired && isFooterEnabled && localeTexts.length" class="footer" [ngClass]="{'stick' : isSticky, 'hideOnMobile': !isMobile}" [attr.data-locale]="currentLocale">

  <div class="separator" *ngIf="isSeparatorRequired"></div>

  <div class="footerBox" [ngClass]=" {'w90' : (widthMode == 'less'), 'w80' : (widthMode == 'more')} ">
    <div class="footerLogo">
      <a rel="noreferrer noopener" href="{{localeTexts[0].footnote[0].content[0].url}}" target="{{localeTexts[0].footnote[0].content[0].newTab == 'TRUE' ? '_blank' : ''}}">
        <img src="{{localeTexts[0].footnote[0].content[0].imageURL}}" alt="{{localeTexts[0].footnote[0].content[0].altText}}" srcset="">
      </a>
    </div>

    <div class="footerTxt">
      <div class="f1">
        <p>
          <span [innerHTML]="firstFootNote"></span>
          <span>{{localeTexts[0].footnote[0].content[2].text}}</span>
          <span>{{localeTexts[0].footnote[0].content[3].text}}</span>
          <span class="lnk">
            <a rel="noreferrer noopener" href="{{localeTexts[0].footnote[0].content[4].url}}" target="{{localeTexts[0].footnote[0].content[4].newTab == 'TRUE' ? '_blank' : ''}}">
              {{localeTexts[0].footnote[0].content[4].text}}
            </a>
          </span>
        </p>
      </div>
      <div class="f2">

        <p>
          <span class="lnk" *ngFor="let link of localeTexts[0].menuList[0].content; let i = index">
            <a rel="noreferrer noopener" href="{{link.url}}" title="{{link.text}}" target="{{link.newTab == 'TRUE' ? '_blank' : ''}}">{{link.text}}</a>
            <span *ngIf="(i+1) != localeTexts[0].menuList[0].content.length">&nbsp;|&nbsp;</span>
          </span>
        </p>

      </div>
    </div>
  </div>

</footer>